import { Component } from '@angular/core';
import {HeroEnterpriseComponent} from "../hero-enterprise/hero-enterprise.component";
import {ValueEmpresarialComponent} from "../value-empresarial/value-empresarial.component";
import {InfluenciaEmpresaComponent} from "../influencia-empresa/influencia-empresa.component";
import {MenuSafeJobComponent} from "../menu-safe-job/menu-safe-job.component";
import {FrecuentlyQuestionsComponent} from "../frecuently-questions/frecuently-questions.component";

@Component({
  selector: 'app-all-main',
  standalone: true,
  imports: [
    HeroEnterpriseComponent,
    ValueEmpresarialComponent,
    InfluenciaEmpresaComponent,
    MenuSafeJobComponent,
    FrecuentlyQuestionsComponent
  ],
  templateUrl: './all-main.component.html',
  styleUrl: './all-main.component.css'
})
export class AllMainComponent {

}
